export const INVENTORY_SETTINGS_IDENTIFIER = '--inventory--'
export const CREDIT_SETTINGS_IDENTIFIER = '--credit--'
export const DELIVERY_SLOTS_IDENTIFIER = '--delivery-slots--'